import "./Styles/style.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LoginProvider } from "./Components/Login/LoginContext.js";
import NotificationProvider from "./Components/UI/NotificationProvider.js";
import ErrorBoundary from "./Components/UI/ErrorBoundary.js";
import Navigation from "./Navigation/Navigation.js";
import HomePage from "./Pages/Home/HomePage.js";
import AdminPage from "./Pages/Admin/AdminPage.js";
import TransferRequestPage from "./Pages/TransferRequest/TransferRequestPage.js";
import ProfilePage from "./Pages/Profile/ProfilePage";
import CompetitionsPage from "./Pages/Competition/CompetitionsPage";
import TeamsPage from "./Pages/Team/TeamsPage";
import UsersPage from "./Pages/User/UsersPage";
import CompetitionPage from "./Pages/Competition/CompetitionPage";
import TeamPage from "./Pages/Team/TeamPage";
import ManagerPage from "./Pages/Manager/ManagerPage";
import UserPage from "./Pages/User/UserPage";
import SeasonPage from "./Pages/Season/SeasonPage";
import PlayerPage from "./Pages/Player/PlayerPage";
import MatchPage from "./Pages/Match/MatchPage";
import AppearancePage from "./Pages/Appearance/AppearancePage";
import DashboardPage from "./Pages/Dashboard/DashboardPage";
import AboutPage from "./Pages/About/AboutPage";
import UpdatesPage from "./Pages/Updates/UpdatesPage";
import NotFoundPage from "./Pages/NotFound/NotFoundPage";
import ProtectedRoute from "./Components/Login/ProtectedRoute.js";
import { ThemeProvider, createTheme } from "@mui/material";

function App() {
  const theme = createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: "#6ec82d",
        dark: "#2d5c1a",
        light: "#8fd955",
      },
      secondary: {
        main: "#1a2332",
        dark: "#0d1119",
        light: "#2d3a4d",
      },
      background: {
        default: "#1a2332",
        paper: "#2d3a4d",
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <LoginProvider>
        <NotificationProvider>
          <Router>
            <div className="App">
              <Navigation></Navigation>
              <ErrorBoundary>
                <Routes>
                  <Route exact path="/" element={<HomePage />} />
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/updates" element={<UpdatesPage />} />
                  <Route exact path="/admin" element={<ProtectedRoute element={<AdminPage />} />} />
                  <Route exact path="/profile" element={<ProfilePage />} />
                  <Route
                    exact
                    path="/competitions"
                    element={<CompetitionsPage />}
                  />
                  <Route exact path="/teams" element={<TeamsPage />} />
                  <Route path="/users" element={<ProtectedRoute element={<UsersPage />} />} />
                  <Route
                    path="/competition/:competitionId"
                    element={<CompetitionPage />}
                  />
                  <Route
                    path="/transferRequests"
                    element={<TransferRequestPage />}
                  />
                  <Route path="/team/:teamId" element={<TeamPage />} />
                  <Route path="/manager/:managerId" element={<ManagerPage />} />
                  <Route path="/user/:userId" element={<UserPage />} />
                  <Route path="/season/:seasonId" element={<SeasonPage />} />
                  <Route path="/player/:playerId" element={<PlayerPage />} />
                  <Route path="/match/:matchId" element={<MatchPage />} />
                  <Route
                    path="/appearance/:appearanceId"
                    element={<AppearancePage />}
                  />
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </ErrorBoundary>
            </div>
          </Router>
        </NotificationProvider>
      </LoginProvider>
    </ThemeProvider>
  );
}

export default App;
